import React, { useState } from "react";
import { TbBrandTwilio } from "react-icons/tb";
import { ThreeDot } from "react-loading-indicators";


const TwiloBilling = () => {
    const [loading,setLoading] = useState(false)
  return (
    <div className="bg-gray-100 p-12 flex justify-center">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 flex items-center">
        {loading ? (
          <div className="flex flex-row justify-center items-center">
            <ThreeDot
              variant="brick-stack"
              color="#4f46e5"
              size="medium"
              text=""
              textColor=""
            />
          </div>
        ) : (
          <>
            {/* Icon Section */}
            <div className="flex-shrink-0 mr-8 -mt-56">
              <TbBrandTwilio className="text-indigo-600 w-24 h-24" />
            </div>
            {/* Content Section */}
            <div className="w-full">
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                Twilio Setup
              </h2>
              {/* Twilio Details Section */}
              {/* <div className="grid grid-cols-2 gap-4 mb-4 text-gray-800">
                <div>
                  <h3 className="font-semibold">Property Name:</h3>
                  <p className="text-gray-600">{propertyName}</p>
                </div>
                <div>
                  <h3 className="font-semibold">Twilio ID:</h3>
                  <p className="text-gray-600">{twilioId}</p>
                </div>
                <div>
                  <h3 className="font-semibold">Account Status:</h3>
                    <p
                        className={`font-medium ${
                        status === "active" ? "text-green-600" : "text-red-600"
                        }`}
                  >
                    {status
                      ? status.charAt(0).toUpperCase() + status.slice(1)
                      : "Inactive"}
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold">Phone Number:</h3>
                  <p className="text-gray-600">{`${countryCode} ${phoneNumber}`}</p>
                </div>
                <div>
                  <h3 className="font-semibold">Messages Sent:</h3>
                  <p className="text-gray-600">{messageCount}</p>
                </div>
                <div>
                  <h3 className="font-semibold">Monthly Limit:</h3>
                  <p className="text-gray-600">1,000 messages</p>
                </div>
              </div>

              <button
                className="bg-indigo-600 hover:bg-indigo-500 text-white font-medium px-4 py-2 rounded-md focus:outline-none transition-all"
                onClick={() => console.log("Start Twilio Setup")}
              >
                Configure Twilio
              </button> */}
                <table class="min-w-full text-sm text-left text-gray-700">
          <thead class="bg-gray-100 text-gray-700 uppercase text-xs">
            <tr>
              <th class="py-3 px-4">Month</th>
              <th class="py-3 px-4">SMS Used</th>
              <th class="py-3 px-4">Phone Number</th>
              <th class="py-3 px-4">Total Cost</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr>
              <td class="py-3 px-4">April 2025</td>
              <td class="py-3 px-4">150</td>
              <td class="py-3 px-4">+1 8883047988</td>
              <td class="py-3 px-4 text-purple-600 font-medium">$3.00</td>
            </tr>
          </tbody>
        </table>

            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TwiloBilling;



{/* <table class="min-w-full text-sm text-left text-gray-700">
          <thead class="bg-gray-100 text-gray-700 uppercase text-xs">
            <tr>
              <th class="py-3 px-4">Month</th>
              <th class="py-3 px-4">SMS Used</th>
              <th class="py-3 px-4">Phone Number</th>
              <th class="py-3 px-4">Total Cost</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr>
              <td class="py-3 px-4">April 2025</td>
              <td class="py-3 px-4">150</td>
              <td class="py-3 px-4">+1 8883047988</td>
              <td class="py-3 px-4 text-purple-600 font-medium">$3.00</td>
            </tr>
          </tbody>
        </table> */}